/* Newsletter-Anmeldung in Footer, Lootbox-Seite und Passwortseite
 *
 * Gegenstueck zu snippets/newsletter.liquid. Schickt die Adresse an den Nerd
 * Mailer und zeigt danach den Hinweis auf die Bestaetigungsmail:
 *
 *   POST /apps/newsletter/api/subscribe   {"email": "...", "source": "footer"}
 *
 * Der Pfad laeuft ueber den Shopify App Proxy: same-origin, von Shopify
 * HMAC-signiert, kein Schluessel im Frontend.
 *
 * Anders als newsletter-anmeldung.js bedient diese Datei MEHRERE Formulare auf
 * derselben Seite. Sie wird einmal aus layout/theme.liquid geladen, weil das
 * Snippet mehrfach gerendert werden kann und ein Skript-Tag im Snippet dann
 * doppelt ausgefuehrt wuerde — jeder Klick loeste zwei Anmeldungen aus.
 *
 * Zur Fehlerbehandlung: Der Server antwortet absichtlich gleich, egal ob die
 * Adresse neu, gesperrt oder schon angemeldet ist. Wir zeigen deshalb bei jeder
 * erfolgreichen Antwort denselben Hinweis.
 */
(function () {
  'use strict';

  var MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('[data-nl-inline]').forEach(function (wurzel) {
    var form = wurzel.querySelector('.nl-inline-form');
    var feld = wurzel.querySelector('input[name="email"]');
    var knopf = wurzel.querySelector('button[type="submit"]');
    var fehlerEl = wurzel.querySelector('[data-nl-fehler]');
    var erfolgEl = wurzel.querySelector('[data-nl-erfolg]');
    if (!form || !feld || !knopf) return;

    var quelle = wurzel.dataset.quelle || 'footer';
    var textEmail = wurzel.dataset.fehlerEmail || 'Bitte gib eine gültige E-Mail-Adresse ein.';
    var textAllgemein = wurzel.dataset.fehlerAllgemein || 'Das hat gerade nicht geklappt.';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      absenden();
    });

    async function absenden() {
      setFehler('');

      var email = (feld.value || '').trim();
      // Nur eine grobe Vorpruefung, damit offensichtliche Tippfehler nicht erst
      // eine Anfrage kosten. Die verbindliche Pruefung macht der Server.
      if (!email || !MAIL.test(email)) {
        setFehler(textEmail);
        feld.focus();
        return;
      }

      setBusy(true);
      try {
        var res = await fetch('/apps/newsletter/api/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            email: email,
            // Erster Besuch dieses Browsers, siehe erstkontakt.js
            erstkontakt: window.gdErstkontakt ? window.gdErstkontakt() : null,
            source: quelle,
            // Sprache der Seite, siehe newsletter-anmeldung.js.
            sprache: wurzel.dataset.sprache || '',
            // Nachweis, dass hier ein Mensch sitzt. Siehe turnstile-gate.js.
            turnstileToken: await (window.gdTurnstile?.holeToken?.() ?? Promise.resolve(null)),
          }),
        });
        var data = await res.json().catch(function () { return null; });

        if (res.ok && data && data.ok) {
          zeigeErfolg();
          return;
        }
        if (data && data.error === 'invalid_email') {
          setFehler(textEmail);
          return;
        }
        setFehler(textAllgemein);
      } catch (err) {
        console.error('[newsletter] Anmeldung fehlgeschlagen', err);
        setFehler(textAllgemein);
      } finally {
        setBusy(false);
      }
    }

    function zeigeErfolg() {
      form.hidden = true;
      if (erfolgEl) {
        erfolgEl.hidden = false;
        // Der Footer liegt weit unten; ohne Fokus bemerkt ein Screenreader den
        // Wechsel nicht, und mit Tastatur landet man sonst im Nichts.
        erfolgEl.setAttribute('tabindex', '-1');
        erfolgEl.focus();
      }
    }

    function setFehler(text) {
      if (!fehlerEl) return;
      fehlerEl.textContent = text;
      fehlerEl.hidden = !text;
    }

    function setBusy(busy) {
      knopf.disabled = busy;
      knopf.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  });
})();
